import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Plantel } from 'src/app/models/Plantel1';
import { DatosClienteService } from 'src/app/services/datos-cliente.service';
import { PlantelService } from 'src/app/services/plantel1.service';
import { MisValidaciones } from 'src/app/utils/mis-validaciones';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { mensajeSesionExpiradaService } from 'src/app/services/mensajeSesionExpirada.service';


@Component({
  selector: 'app-registro-aspirante',
  templateUrl: './registro-aspirante.component.html',
  styleUrls: ['./registro-aspirante.component.css'],
})
export class RegistroAspiranteComponent implements OnInit {
  mailusu = 'Registro fuera de SIGE';
  //Año del periodo de preinscripción
  anioInscripcion: string = '';

  formulario!: FormGroup;

  plantelesLista: Plantel[] = [];
  estados: any = [];
  sexoLista: string[] = [];
  pueblosindigenas: string[] = [];
  idiomaingles: string[] = [];
  nivelesingles: string[] = [];
  generosLista: string[] = [];
  deportesLista: string[] = [];
  etapaCompetenciaLista: string[] = [];
  disciplinasLista: string[] = [];
  olimpiadasConocimientoLista: string[] = [];

  //Mostrat campos o no en pantalla
  disciplinaDiferenteSeleccionada: boolean = false;
  olimpiadaDiferenteSeleccionada: boolean = false;

  curpRecibida: string = '';

  //Mensaje Selectores
  cadenaindigena: string = 'Si';
  cadenaOtraSeleccion: string = 'Otro';
  mensajeSeleccioneOpcion: string = 'Seleccione una opción...';

  //Información de Avisos
  tituloModal: string = '';
  mensajeModal: string = '';
  modalUtilizado: string = '';
  mantenerModal: boolean = false;
  actualizarModal: number = 0;

  SiIndigena: boolean = false;
  Sihablalengua: boolean = false;
  Sidoblenacionalidad: boolean = false;
carreras: any =[];

  constructor( ) {}
  ngOnInit(): void {
   


  }

 
  
}
